export default __webpack_public_path__ + "img/catIcon10.aa4bc07d.svg";